import { ABISmartContractProcessor } from './ABISmartContractProcessor';
export const getABI = (context, contractInfo) => new ABISmartContractProcessor(context, contractInfo).process();

//# sourceMappingURL=getABI.js.map
